import { FC, useMemo, useState } from "react";

import Select from "react-select";
import _ from "lodash";
import config from "config";
import { useClassOfBusinesses } from "hooks/data/use-class-of-business";

interface Option {
  label: {
    title: string;
    imageUrl?: string;
  };
  value: string | object;
}

interface BusinessPickerProps {
  id: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  optionsLoading?: boolean;
  setFieldValue: any;
  setFieldTouched: any;
  setFieldError: any;
  rounded?: boolean;
  rawId?: boolean;
  isMulti?: boolean;
  addAllOption?: boolean;
  filter?: string;
}

const BusinessPicker: FC<BusinessPickerProps> = ({
  id,
  values,
  setFieldValue,
  setFieldTouched,
  placeholder,
  label,
  errors,
  touched,
  required,
  labelHidden,
  disabled,
  isMulti,
  rawId,
  addAllOption,
  filter = "",
}) => {
  const [query] = useState("");
  const { classOfBusinesses, loading } = useClassOfBusinesses({
    page: 1,
    pageSize: 700,
    search: query,
    category: "",
  });
  let list = classOfBusinesses;
  console.log("classOfBusinesses", classOfBusinesses.length);
  const hasFilter = filter !== "" && !filter.includes("All");
  // if filter is provided, filter the class of businesses
  if (hasFilter && config.appDomain === "Visal") {
    list = classOfBusinesses.filter((el) =>
      filter.includes(el.business_category as string)
    );
  } else {
    list = classOfBusinesses;
  }

  const options = useMemo(
    () => [
      ...(addAllOption ? [{ label: "All", value: "ALL" }] : []),
      ...list.map(({ class_of_business_id, business_name, ...rest }) => ({
        label: business_name,
        value: rawId
          ? class_of_business_id
          : { class_of_business_id, business_name, ...rest },
      })),
    ],
    [classOfBusinesses]
  );

  const filteredOptions =
    query === ""
      ? options
      : options.filter((option) => {
          return option.label.toLowerCase().includes(query.toLowerCase());
        });

  const selectedValue = useMemo(() => {
    if (options.length === 0) return null;
    if (isMulti) {
      return (values[id] || []).map((val: string) =>
        options.find((o) => o.value === val)
      );
    } else {
      const compareItem = rawId ? values[id] : values[id].business_name;
      return options.find((o) => o[rawId ? "value" : "label"] === compareItem);
    }
  }, [values[id], options]);

  const handleChange = (selectedOptions: any): void => {
    if (isMulti && Array.isArray(selectedOptions)) {
      const selectedValues = selectedOptions.map((option) => option.value);
      setFieldTouched(id, true);
      setFieldValue(id, selectedValues);
    } else {
      const selectedValue = selectedOptions ? selectedOptions.value : null;
      setFieldTouched(id, true);
      setFieldValue(id, selectedValue);
    }
  };

  return (
    <div>
      {!labelHidden && (
        <label className="block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      {/* {JSON.stringify(selectedValue, null, 2)} */}

      <Select
        options={[...filteredOptions]}
        value={selectedValue}
        onChange={handleChange}
        isLoading={loading}
        placeholder={placeholder}
        isDisabled={disabled}
        isMulti={isMulti}
        className="w-full mt-1"
      />
      {_.get(errors, id) && _.get(touched, id) && (
        <p className="mt-2 text-sm text-red-600" id={`${id}-error`}>
          {_.get(errors, id)}
        </p>
      )}
    </div>
  );
};

export default BusinessPicker;
